var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouldNotDetermine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "26px",
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "could_not_determine") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Results---1-potentially-eligible-(A)",
    transform: "translate(-737.000000, -758.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(240.000000, 745.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(271.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(226.000000, 5.352941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "could_not_determine",
    transform: "translate(0.000000, 0.470588)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#3E2A79",
    strokeWidth: 2,
    cx: 12,
    cy: 12,
    r: 11
  }), /*#__PURE__*/React.createElement("text", {
    id: "?",
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 16,
    fontWeight: "bold",
    fill: "#3C2075"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 7.632,
    y: 18.1764706
  }, "?"))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouldNotDetermine);
export default __webpack_public_path__ + "static/media/could_not_determine.494eda9aa7161ff12b7bb03995cfd254.svg";
export { ForwardRef as ReactComponent };